import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { DEFAULT_LOGOUT_MESSAGE, LOGOUT_SESSION_ENDED_COPY } from '@/constants'
import { useSessionStore } from '@/stores'
import { useLogoutSequence } from '@hooks/useLogoutSequence'
import { GlobalLoading } from '@components/LoadingSpinner'
import SessionComplete from '@components/steps/SessionComplete'
import OmpHeader from '../sections/OmpHeader'
import OmpFooter from '../sections/OmpFooter'
import { applyOmpTheme, getThemeVariables } from '../utils/themeTokens'

// The funnel's goodbye card, unchanged, inside this portal's chrome. `.omp-logout-main`
// repoints the card's design tokens at the portal's, so it follows the OMP theme.
const OmpLogout = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const campaign = useSessionStore(s => s.campaign) as any

  const message = searchParams.get('msg') || DEFAULT_LOGOUT_MESSAGE
  const ready = useLogoutSequence(message)

  // The campaign outlives logout, so the brand's tokens stay applied on the way out.
  const themeVariables = getThemeVariables(campaign)
  useEffect(() => {
    applyOmpTheme(themeVariables)
  }, [themeVariables])

  return (
    <div className="omp-root omp-auth-root">
      <OmpHeader />
      <main className="omp-logout-main">
        {ready && (
          <SessionComplete onAction={() => navigate('/', { replace: true })}>
            <div>{message}</div>
            <p className="mt-2" style={{ color: 'var(--light-text-color)' }}>
              {LOGOUT_SESSION_ENDED_COPY}
            </p>
          </SessionComplete>
        )}
      </main>
      <OmpFooter />
      <GlobalLoading />
    </div>
  )
}

export default OmpLogout
